import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Schema from 'lib/schema'


import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import ChipInput from 'material-ui-chip-input'
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import {TimespanPicker} from '../TimespanPicker';
import _ from 'lodash';
import { isNumber } from 'utils';
const operators = {
  'eq':{
    'description': 'Equal',
    'symbol': '=',
    'types': ['string', 'number', 'boolean', 'date-time', 'uuid'],
    'operator': 'eq',
    'negate':false,
  },
  '!eq':{
    'description': 'Not Equal',
    'symbol': '=',
    'types': ['string', 'number', 'boolean', 'date-time', 'uuid'],
    'operator': 'eq',
    'negate':true,
  },
  'gt':{
    'description': 'Greater than',
    'symbol': '>',
    'types' :['number', 'array', 'date-time'],
    'operator': 'gt',
    'negate':false,
  },
  '!gt':{
    'description': 'Not greater than',
    'symbol': '>',
    'types' :['number', 'array', 'date-time'],
    'operator': 'gt',
    'negate':true,
  },
  'lt':{
    'description': 'Less than',
    'symbol': '<',
    'types' :['number', 'array', 'date-time'],
    'operator': 'lt',
    'negate':false,
  },
  '!lt':{
    'description': 'Not less than',
    'symbol': '<',
    'types' :['number', 'array', 'date-time'],
    'operator': 'lt',
    'negate':true,
  },
  'contains':{
    'description': 'Contains',
    'symbol': 'C',
    'types': ['string', 'array'],
    'operator': 'contains',
    'negate':false,
  },
  '!contains':{
    'description': 'Not contains',
    'symbol': 'C',
    'types': ['string', 'array'],
    'operator': 'contains',
    'negate':true,
  },
  'in':{
    'description': 'In',
    'symbol': 'in',
    'types': ['string', 'number', 'uuid'],
    'operator': 'in',
    'negate':false,
  },
  '!in':{
    'description': 'Not in',
    'symbol': 'in',
    'types': ['string', 'number', 'uuid'],
    'operator': 'in',
    'negate':true,
  },
  'regex':{
    'description': 'Regex',
    'symbol': '(.*)',
    'types' :['string', 'array'],
    'operator': 'regex',
    'negate':false,
  },
  '!regex':{
    'description': 'Negate Regex',
    'symbol': '(.*)',
    'types' :['string', 'array'],
    'operator': 'regex',
    'negate':true,
  }
}

const getDefaultFilterValue = (valueType,editorValues)=>{
  const {value}=editorValues;

  if (valueType ==='boolean' && !_.isBoolean(value)){
    return false;
  }
  else if (valueType ==='string' && !_.isString(value)){
    return '';
  }
  else if (valueType ==='number' && !isNumber(value)){
    return '0';
  }
  return value;
}
const filterFieldStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.shape.padding
  },
  formControl: {
    margin: theme.spacing(1)
  },
  rightMargin: {
    marginTop: -5, // this accounts for the helper text
    marginRight: theme.shape.padding
  }
}))

const FilterField = (props) => {
  const classes = filterFieldStyles();
  const [schema, setSchema] = useState(Schema.getSchema(props.namespace).schema.properties) /* eslint-disable-line */
  const [editorValues, setEditorValues] = useState({
    field: props.fields[0].field,
    operator: 'eq',
    ...props.control
  })

  useEffect(() => {
    const operator = Object.keys(operators).find(op=>operators[op].types.includes(schema[editorValues.field].type))
    const eValues = {...editorValues, operator,
       value:getDefaultFilterValue(schema[editorValues.field].type,editorValues)
    }
    setEditorValues(eValues)
  },[editorValues.field]) /* eslint-disable-line */


  const setQueryParam = (value) => {
    setEditorValues({...editorValues, ...value})
  }
  const handleAddChip = (value) => {
    const chips = Array.isArray(editorValues.value) ? editorValues.value : [editorValues.value] 
    setQueryParam({value:[...chips, value]})
  }
  const handleDeleteChip = (chip, index) => {
    const chips = Array.isArray(editorValues.value) ? editorValues.value : [editorValues.value] 
    setQueryParam({value:chips.filter((k,i)=> i!==index)})
  }

  const handleChangeOperator =(e)=>{
    const {negate,operator} = operators[Object.keys(operators).find((k=>k===e.target.value))];
    setQueryParam({operator,negate});
  }

  const handleUpdate = () => {
    if(editorValues.uuid){
      props.interface.update(editorValues.uuid, editorValues)
    } else {
      props.interface.add(editorValues)
    }
    if(props.onComplete){
      props.onComplete()
    }
  }

  const handleCancel = () => {
    if(props.onComplete){
      props.onComplete()
    }
  }

  const renderEditField = () => {
    const fieldParams = props.fields.find(f=>f.field === editorValues.field)
    if(fieldParams && fieldParams.options){
      return (
        <Select
          value={editorValues.value === undefined ? '' : editorValues.value}
          onChange={(e)=>setQueryParam({value:e.target.value})}
        >
          {fieldParams.options.map(o=>(<MenuItem key={`fieldParams-${o.value}`} value={o.value}>{o.label}</MenuItem>))}
        </Select>
      )
    }
    else if(editorValues.operator === 'in' && schema[editorValues.field].format !== 'date-time'){
      return (
        <ChipInput
          onAdd={handleAddChip}
          onDelete={handleDeleteChip}
          blurBehavior = 'add'
          value={editorValues.value && editorValues.value.map ? editorValues.value || [] : [editorValues.value]}
        />
      )
    }else{
      switch (schema[editorValues.field].type) {
        case 'string':
          if(schema[editorValues.field].format === 'date-time'){
            return (
              <TimespanPicker
                startTime={editorValues.value || ''}
                setTimes={(startTime, endTime)=>setQueryParam({value:startTime})}
              />
            )
          }else{
            return (
              <TextField
                value={editorValues.value || ''}
                id={`QueryParamControl-${editorValues.uuid}`}
                onChange={(e)=>setQueryParam({value:e.target.value})}
              />
            )
          }
        case 'number':
          return (
            <TextField
              type='number'
              value={editorValues.value || ''}
              InputProps={{ disableUnderline: true }}
              id={`QueryParamControl-${editorValues.uuid}`}
              onChange={(e)=>setQueryParam({value:e.target.value})}
            />
          )
        case 'array':
          if(editorValues.operator==='contains'){
            return(
              <TextField
              value={editorValues.value || ''}
              id={`QueryParamControl-${editorValues.uuid}`}
              onChange={(e)=>setQueryParam({value:e.target.value})}
              />
            )
          } else if(['gt','lt'].includes(editorValues.operator)){
            return (
              <TextField
                type='number'
                value={editorValues.value || ''}
                InputProps={{ disableUnderline: true }}
                id={`QueryParamControl-${editorValues.uuid}`}
                onChange={(e)=>setQueryParam({value:e.target.value})}
              />
            )
          }else{
            return (
              <ChipInput
                onAdd={handleAddChip}
                onDelete={handleDeleteChip}
                blurBehavior = 'add'
                value={editorValues.value || []}
              />
            )
          }
        case 'boolean':
          return (
            <Switch
              id={`QueryParamControl-${editorValues.uuid}`}
              checked={editorValues.value || false}
              onChange={(e)=>setQueryParam({value:e.target.checked})}
            />
          )
        default:
          return (
            <Skeleton variant="text" />
          )
      }
    }
  }

  return (
    <Paper className={classes.paper}>
      <Select
        value={editorValues.field}
        className={classes.rightMargin}
        onChange={(e)=>setQueryParam({field:e.target.value})}
      >
        {props.fields.map(obj=>(
          <MenuItem key={obj.field} value={obj.field}>{obj.display_name || obj.field}</MenuItem>
        ))}
      </Select>

      <Select
        value={'negate' in editorValues && editorValues.negate ===true ? `!${editorValues.operator}` :editorValues.operator}
        className={classes.rightMargin}
        onChange={(e)=> handleChangeOperator(e)}
      >
        {Object.keys(operators).map(op=>(
          <MenuItem disabled={!operators[op].types.includes(schema[editorValues.field].type)} key={op} value={op}>{operators[op].description}</MenuItem>
        ))}
      </Select>
      {renderEditField()}
      <Button onClick={handleUpdate}>Done</Button>
      <Button onClick={handleCancel}>Cancel</Button>
    </Paper>
  )
}

// ** Proptypes ***********************
FilterField.propTypes = {
  namespace: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  onComplete: PropTypes.func
};

// ** Default props *******************
FilterField.defaultProps = {
  control: {},
};


export default FilterField